import { OrderRoutePaths } from "./orders-routes.enum";

// This file contains only metadata for order steps, no component references.
//   quantumMetricAllow: true  -> captures the page and sends to QM
//   quantumMetricBlock: true  -> won't capture the page, and if previously opted in another route, will opt the user out of QM capture
export const orderStepMetadata = [
  {
    path: OrderRoutePaths.ORDER_SETUP,
    data: {
      title: "Order Setup",
      subHeader: "Select from options below to complete your order setup.",
      step: "order-setup",
      quantumMetricAllow: true
    }
  },
  {
    path: OrderRoutePaths.ALL_SERVICES_DOWN,
    data: {
      title: "All Services Down",
      subHeader: "Our services are not available now. Please check back later.",
      step: "all-services-down",
      quantumMetricAllow: true
    }
  },
  {
    path: OrderRoutePaths.SERVICE_INFORMATION,
    data: {
      title: "Service Information Collection",
      subHeader: "Fill out information about the customer below.",
      step: "service-information-collection",
      quantumMetricAllow: true
    }
  },
  {
    path: OrderRoutePaths.PREVIOUS_ADDRESS_COLLECTION,
    data: {
      title: "Previous Address Collection",
      subHeader: "Please provide your previous address below.",
      step: "previous-address-collection",
      quantumMetricAllow: true
    }
  },
  {
    path: OrderRoutePaths.BUNDLE_HOMEPAGE,
    data: {
      title: "Bundle Homepage",
      subHeader: "Choose from the options below.",
      step: "bundle-homepage",
      quantumMetricAllow: true
    }
  },
  {
    path: OrderRoutePaths.INTERNET_PACKAGE_SELECTION,
    data: {
      title: "Package Selection",
      subHeader: "Choose from the options below.",
      step: "internet-package-selection",
      quantumMetricAllow: true
    }
  },
  {
    path: OrderRoutePaths.VIDEO_PACKAGE_SELECTION,
    data: {
      title: "Package Selection",
      subHeader: "Choose from the options below.",
      step: "video-package-selection",
      // quantumMetricAllow: true
    }
  },
  {
    path: OrderRoutePaths.VOICE_PACKAGE_SELECTION,
    data: {
      title: "Voice Package Selection",
      subHeader: "Pick a Voice plan below.",
      step: "voice-package-selection"
    }
  },
  {
    path: OrderRoutePaths.VOICE_CONFIGURATION,
    data: {
      title: "Voice configuration",
      subHeader: "Configure new lines below.",
      step: "voice-configuration"
    }
  },
  {
    path: OrderRoutePaths.ADDITIONAL_CHANNEL_OFFERS,
    data: {
      title: "Additional Channel Offers",
      subHeader: "Choose from additional channel offers below.",
      step: "additional-channel-offers",
      // quantumMetricAllow: true
    }
  },
  {
    path: OrderRoutePaths.CLOSING_OFFERS,
    data: {
      title: "Closing Offers",
      subHeader: "Choose from closing offers below.",
      step: "closing-offers",
      // quantumMetricAllow: true
    }
  },
  {
    path: OrderRoutePaths.STREAM_GENRE_PACK,
    data: {
      title: "Video Package Selection",
      subHeader: "Choose from genre packs below.",
      step: "stream-genre-pack",
      // quantumMetricAllow: true
    }
  },
  {
    path: OrderRoutePaths.EMAIL_VALIDATION,
    data: {
      title: "Email Validation",
      subHeader: "Validate the email address for the customer account.",
      step: "email-validation",
      // quantumMetricAllow: true
    }
  },
  {
    path: OrderRoutePaths.REQUIRED_CALL,
    data: {
      title: "Required Call Components (RCC)",
      subHeader: "Please complete the RCC review below.",
      step: "required-call",
      // quantumMetricAllow: true
    }
  },
  {
    path: OrderRoutePaths.CREDIT_CHECK,
    data: {
      title: "Credit Check",
      subHeader: "Review the customer information below.",
      step: "credit-check",
      quantumMetricBlock: true
    }
  },
  {
    path: OrderRoutePaths.CREDIT_RESULTS,
    data: {
      title: "Credit Results",
      subHeader: "Review the credit results below.",
      step: "credit-results",
      quantumMetricBlock: true
    }
  },
  {
    path: OrderRoutePaths.NCVC_QUESTIONNAIRE,
    data: {
      title: "NCVC Questionnaire",
      subHeader: "Please answer questions below.",
      step: "ncvc-questionnaire",
      quantumMetricAllow: true
    }
  },
  {
    path: OrderRoutePaths.ACCOUNT_REVIEW,
    data: {
      title: "AT&T Credit Check Result",
      subHeader: "Please complete account review below.",
      step: "account-review",
      quantumMetricBlock: true
    }
  },
  {
    path: OrderRoutePaths.ADVANCED_BILL_PAYMENT,
    data: {
      title: "Advanced Bill Payment",
      subHeader: "Make a selection below.",
      step: "advanced-bill-payment",
      quantumMetricBlock: true
    }
  },
  {
    path: OrderRoutePaths.ADDITIONAL_INTERNET_OFFERS,
    data: {
      title: "Additional Internet Offers",
      subHeader: "Select additional internet options below.",
      step: "additional-internet-offers",
      quantumMetricAllow: true
    }
  },
  {
    path: OrderRoutePaths.ADDITIONAL_VOICE_OFFERS,
    data: {
      title: "Additional Voice Offers",
      subHeader: "Review voice offers below.",
      step: "additional-voice-offers",
      quantumMetricAllow: true
    }
  },
  {
    path: OrderRoutePaths.ADDITIONAL_WIRELESS_OFFERS,
    data: {
      title: "Additional Wireless Offers",
      subHeader: "Select additional wireless options below.",
      step: "additional-wireless-offers",
      // quantumMetricAllow: true
    }
  },
  {
    path: OrderRoutePaths.ALTERNATE_SHIPPING,
    data: {
      title: "Customer Address Preferences",
      subHeader: "Enter additional addresses as needed.",
      step: "alternate-shipping",
      quantumMetricAllow: true
    }
  },
    {
    path: OrderRoutePaths.SERVICE_LEVEL_SELECTION,
    data: {
      title: "Shipping Preferences",
      subHeader: "Choose from shipping options below.",
      step: "service-level-selection",
      // quantumMetricAllow: true
    }
  },
  {
    path: OrderRoutePaths.CUSTOMER_ACCOUNT_SETUP,
    data: {
      title: "Customer Account Set Up",
      subHeader: "Provide customer information below.",
      step: "customer-account-setup",
      quantumMetricBlock: true
    }
  },
  {
    path: OrderRoutePaths.WINDSTREAM_CUSTOMER_ACCOUNT_SETUP,
    data: {
      title: "Windstream Customer Account Setup",
      subHeader: "Provide customer information below.",
      step: "windstream-customer-account-setup",
      // quantumMetricAllow: true
    }
  },
  {
    path: OrderRoutePaths.PRODUCT_SUMMARY,
    data: {
      title: "Product Summary",
      subHeader: "Review selections below.",
      step: "product-summary",
      quantumMetricAllow: true
    }
  },
  {
    path: OrderRoutePaths.TERMS_AND_CONDITIONS,
    data: {
      title: "Terms Conditions and Disclosures",
      subHeader: "To use the provider's services, you must accept and acknowledge these terms, conditions, and disclosures.",
      step: "terms-and-conditions",
      quantumMetricAllow: true
    }
  },
  {
    path: OrderRoutePaths.ORDER_CHECKLIST,
    data: {
      title: "Order Checklist",
      subHeader: "Please read through the items below.",
      step: "order-checklist",
      quantumMetricAllow: true
    }
  },
  {
    path: OrderRoutePaths.CUSTOMER_ORDER_VERIFICATION,
    data: {
      title: "First Party Verification (FPV)",
      subHeader: "Please read through the items below.",
      step: "customer-order-verification",
      // quantumMetricAllow: true
    }
  },
  {
    path: OrderRoutePaths.THIRD_PARTY_VERIFICATION,
    data: {
      title: "Third Party Verification (TPV)",
      subHeader: "Follow the steps below to complete TPV.",
      step: "third-party-verification",
      // quantumMetricAllow: true
    }
  },
  {
    path: OrderRoutePaths.INSTALLATION_SCHEDULING,
    data: {
      title: "Installation Scheduling",
      subHeader: "Select from options below.",
      step: "installation-scheduling",
      quantumMetricAllow: true
    }
  },
  {
    path: OrderRoutePaths.PAYMENT_INFORMATION,
    data: {
      title: "Payment Information Entry",
      subHeader: "Review payment information below.",
      step: "payment-information",
      quantumMetricBlock: true
    }
  },
  {
    path: OrderRoutePaths.INSTALLATION_CHECKLIST,
    data: {
      title: "Installation Checklist",
      subHeader: "Complete installation checklist below.",
      step: "installation-checklist",
      // quantumMetricAllow: true
    }
  },
  {
    path: OrderRoutePaths.ORDER_SUMMARY,
    data: {
      title: "Order Summary",
      subHeader: "Please review your order summary below.",
      step: "order-summary",
      quantumMetricAllow: true
    }
  },
  {
    path: OrderRoutePaths.ORDER_REVIEW,
    data: {
      title: "Order Review",
      subHeader: "Please review order information below.",
      step: "order-review",
      // quantumMetricAllow: true
    }
  },
  {
    path: OrderRoutePaths.ORDER_OPTIONS,
    data: {
      title: "Order Options",
      subHeader: "Please review Order Options below.",
      step: "order-options",
      quantumMetricAllow: true
    }
  },
  {
    path: OrderRoutePaths.OUTSTANDING_BALANCE,
    data: {
      title: "Outstanding Balance",
      subHeader: "Payment collection is required to proceed.",
      step: "outstanding-balance",
      quantumMetricBlock: true
    }
  },
  {
    path: OrderRoutePaths.STREAM_HARDWARE_SELECTION,
    data: {
      title: "Hardware Selection",
      subHeader: "Choose hardware below.",
      step: "stream-hardware-selection",
      // quantumMetricAllow: true
    }
  },
  {
    path: OrderRoutePaths.SATELLITE_HARDWARE_SELECTION,
    data: {
      title: "Hardware Selection",
      subHeader: "Choose hardware below.",
      step: "satellite-hardware-selection",
      // quantumMetricAllow: true
    }
  },
  {
    path: OrderRoutePaths.ADDITIONAL_VIDEO_OFFERS,
    data: {
      title: "Additional Video Offers",
      subHeader: "Choose from included channel offers below.",
      step: "additional-video-offers",
      // quantumMetricAllow: true
    }
  },
  {
    path: OrderRoutePaths.WIRELESS_SETUP,
    data: {
      title: "Wireless Setup",
      subHeader: "Choose from the options below.",
      step: "wireless-setup",
      quantumMetricAllow: true
    }
  },
  {
    path: OrderRoutePaths.BUSINESS_VERIFICATION,
    data: {
      title: "Business Verification",
      subHeader: "Complete business verification steps below.",
      step: "business-verification",
      // quantumMetricAllow: true
    }
  },
  {
    path: OrderRoutePaths.LINE_CONFIGURATION,
    data: {
      title: "Wireless Lines Overview",
      subHeader: "Configure new lines here",
      step: "line-configuration",
      quantumMetricAllow: true
    }
  },
  {
    path: OrderRoutePaths.SIGFAN,
    data: {
      title: "Signature Discount",
      subHeader: "complete the steps below",
      step: "signature-discount",
      quantumMetricAllow: true
    }
  },
   {
    path: OrderRoutePaths.MOBILE_BUSINESS_AGREEMENT,
    data: {
      title: "Mobile Business Agreement",
      subHeader: "The agreement is completed by the customer.",
      step: "mobile-business-agreement",
    }
  },
];
